import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterPanel = ({ isOpen, onClose, filters, onFiltersChange, onApplyFilters, onClearFilters }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const userOptions = [
    { value: '', label: 'All Users' },
    { value: 'ahmed.rashid', label: 'Ahmed Al-Rashid' },
    { value: 'fatima.hassan', label: 'Fatima Hassan' },
    { value: 'omar.abdullah', label: 'Omar Abdullah' },
    { value: 'sara.mohammed', label: 'Sara Mohammed' },
    { value: 'khalid.ahmed', label: 'Khalid Ahmed' }
  ];

  const actionTypeOptions = [
    { value: '', label: 'All Actions' },
    { value: 'login', label: 'User Login' },
    { value: 'logout', label: 'User Logout' },
    { value: 'invoice_create', label: 'Invoice Creation' },
    { value: 'invoice_update', label: 'Invoice Update' },
    { value: 'invoice_delete', label: 'Invoice Deletion' },
    { value: 'zatca_submit', label: 'ZATCA Submission' },
    { value: 'settings_change', label: 'Settings Change' },
    { value: 'user_create', label: 'User Creation' },
    { value: 'user_update', label: 'User Update' },
    { value: 'export', label: 'Data Export' }
  ];

  const statusOptions = [
    { value: '', label: 'All Status' },
    { value: 'success', label: 'Success' },
    { value: 'failed', label: 'Failed' },
    { value: 'pending', label: 'Pending' },
    { value: 'warning', label: 'Warning' }
  ];

  const handleFilterChange = (key, value) => {
    const updatedFilters = { ...localFilters, [key]: value };
    setLocalFilters(updatedFilters);
  };

  const handleApply = () => {
    onFiltersChange(localFilters);
    onApplyFilters();
    onClose();
  };

  const handleClear = () => {
    const clearedFilters = {
      dateFrom: '',
      dateTo: '',
      user: '',
      actionType: '',
      status: '',
      search: ''
    };
    setLocalFilters(clearedFilters);
    onFiltersChange(clearedFilters);
    onClearFilters();
  };

  return (
    <>
      {/* Mobile Backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}
      {/* Filter Panel */}
      <div className={`
        fixed top-0 right-0 h-full w-80 bg-card border-l border-border z-50 transform transition-transform duration-300
        ${isOpen ? 'translate-x-0' : 'translate-x-full'}
        lg:relative lg:translate-x-0 lg:w-full lg:h-auto lg:border-l-0 lg:border lg:rounded-xl
      `}>
        <div className="flex flex-col h-full lg:h-auto">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-border lg:border-b-0">
            <h3 className="text-lg font-semibold text-foreground">Filter Logs</h3>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              className="lg:hidden"
            >
              <Icon name="X" size={20} />
            </Button>
          </div>

          {/* Filter Content */}
          <div className="flex-1 p-6 space-y-6 overflow-y-auto">
            {/* Date Range */}
            <div className="space-y-4">
              <h4 className="text-sm font-medium text-foreground">Date Range</h4>
              <div className="grid grid-cols-1 gap-4">
                <Input
                  label="From Date"
                  type="date"
                  value={localFilters?.dateFrom}
                  onChange={(e) => handleFilterChange('dateFrom', e?.target?.value)}
                />
                <Input
                  label="To Date"
                  type="date"
                  value={localFilters?.dateTo}
                  onChange={(e) => handleFilterChange('dateTo', e?.target?.value)}
                />
              </div>
            </div>

            {/* User Filter */}
            <div className="space-y-2">
              <Select
                label="User"
                options={userOptions}
                value={localFilters?.user}
                onChange={(value) => handleFilterChange('user', value)}
                placeholder="Select user"
              />
            </div>

            {/* Action Type Filter */}
            <div className="space-y-2">
              <Select
                label="Action Type"
                options={actionTypeOptions}
                value={localFilters?.actionType}
                onChange={(value) => handleFilterChange('actionType', value)}
                placeholder="Select action type"
                searchable
              />
            </div>

            {/* Status Filter */}
            <div className="space-y-2">
              <Select
                label="Status"
                options={statusOptions}
                value={localFilters?.status}
                onChange={(value) => handleFilterChange('status', value)}
                placeholder="Select status"
              />
            </div>

            {/* Search */}
            <div className="space-y-2">
              <Input
                label="Search"
                type="search"
                placeholder="Search in logs..."
                value={localFilters?.search}
                onChange={(e) => handleFilterChange('search', e?.target?.value)}
              />
            </div>
          </div>

          {/* Actions */}
          <div className="p-6 border-t border-border space-y-3">
            <Button
              variant="default"
              fullWidth
              onClick={handleApply}
              iconName="Filter"
              iconPosition="left"
            >
              Apply Filters
            </Button>
            <Button
              variant="outline"
              fullWidth
              onClick={handleClear}
              iconName="RotateCcw"
              iconPosition="left"
            >
              Clear All
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterPanel;

